module.exports = __webpack_public_path__ + "static/media/defaultAppIcon.7d1de0a1.png";